import(/* webpackMode: "eager" */ "/workspace/app/auth/login/page.tsx");
